var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 34,
    viewBox: "0 0 4 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C2.20914 0 4 1.79086 4 4V30C4 32.2091 2.20914 34 0 34V0Z",
    fill: "#F74542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/tr.8e49c653070ddf3282616678a0f71cbb.svg";
export { ForwardRef as ReactComponent };